var map = {
	"./ar.svg": "4f88",
	"./cn.svg": "8f59",
	"./de.svg": "eca6",
	"./en.svg": "54f5",
	"./es.svg": "9a2f",
	"./fr.svg": "8f00",
	"./id.svg": "488d",
	"./it.svg": "a248",
	"./ja.svg": "b374",
	"./kh.svg": "9b99",
	"./kr.svg": "b9f9",
	"./la.svg": "032d",
	"./ms.svg": "ee26",
	"./th.svg": "7776",
	"./vi.svg": "3d4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e83";